/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';

/**
 * 
 * @export
 * @interface CompanyOverviewDtoSortingRequestDto
 */
export interface CompanyOverviewDtoSortingRequestDto {
    /**
     * Sortable fields for CompanyOverviewDto: name, totalOrderAmount, totalOrderCount, fullAddress
     * @type {CompanyOverviewDtoSortingRequestDtoSortByEnum}
     * @memberof CompanyOverviewDtoSortingRequestDto
     */
    sortBy?: CompanyOverviewDtoSortingRequestDtoSortByEnum | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof CompanyOverviewDtoSortingRequestDto
     */
    sortDir?: SortDirection;
}


/**
 * @export
 */
export const CompanyOverviewDtoSortingRequestDtoSortByEnum = {
    name: 'name',
    totalOrderAmount: 'totalOrderAmount',
    totalOrderCount: 'totalOrderCount',
    fullAddress: 'fullAddress'
} as const;
export type CompanyOverviewDtoSortingRequestDtoSortByEnum = typeof CompanyOverviewDtoSortingRequestDtoSortByEnum[keyof typeof CompanyOverviewDtoSortingRequestDtoSortByEnum];


/**
 * Check if a given object implements the CompanyOverviewDtoSortingRequestDto interface.
 */
export function instanceOfCompanyOverviewDtoSortingRequestDto(value: object): value is CompanyOverviewDtoSortingRequestDto {
    return true;
}

export function CompanyOverviewDtoSortingRequestDtoFromJSON(json: any): CompanyOverviewDtoSortingRequestDto {
    return CompanyOverviewDtoSortingRequestDtoFromJSONTyped(json, false);
}

export function CompanyOverviewDtoSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOverviewDtoSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function CompanyOverviewDtoSortingRequestDtoToJSON(json: any): CompanyOverviewDtoSortingRequestDto {
    return CompanyOverviewDtoSortingRequestDtoToJSONTyped(json, false);
}

export function CompanyOverviewDtoSortingRequestDtoToJSONTyped(value?: CompanyOverviewDtoSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': value['sortBy'],
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

